// src/hooks/useLearners.js
import { useEffect, useState } from "react";
import { message } from "antd";
import learnersService from "PlatForms/OrgLMS/Services/ManagerService/learnersService";

const useLearners = (managerId) => {
  const [learners, setLearners] = useState([]);
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("token");
  const [pagination, setPagination] = useState({
    totalCount: 0,
    pageNumber: 1,
    pageSize: 10,
    totalPages: 1,
  });

  const fetchLearners = async (page = 1) => {
    setLoading(true);
    try {
      const data = await learnersService.getLearnersByManager(managerId, token, {
        pageNumber: page,
        pageSize: pagination.pageSize,
      });
      setLearners(data.items || []);
      setPagination({
        totalCount: data.totalCount,
        pageNumber: data.pageNumber,
        pageSize: data.pageSize,
        totalPages: data.totalPages,
      });
    } catch (error) {
      message.error("Failed to fetch learners");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (page) => {
    fetchLearners(page);
  };

  useEffect(() => {
    if (managerId) fetchLearners();
  }, [managerId]);

  return {
    learners,
    loading,
    pagination,
    handlePageChange,
    refresh: fetchLearners,
  };
};

export default useLearners;
